import { Component } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';
import Vue from 'vue';
import { router, validation } from '@/_helpers';
import MDTextFieldWithValidation from '@/components/Validation/MDTextFieldWithValidation';
import countries from '@/_helpers/countries';
import customer from '@/store/modules/customer';
import notifier from '@/_helpers/notifier';
import template from './Add.vue';

@Component({
	components: {
		ValidationObserver,
		MDTextFieldWithValidation
	},
	mixins: [template]
})
export default class Add extends Vue {
	countries: {}[] = [];

	name: string = '';

	email: string = '';

	phoneNumber: string = '';

	adminEmail: string = '';

	loading: boolean = false;

	mounted() {
		this.countries = countries;
	}

	async add() {
		const isValid = await (this.$refs.form as any).validate();
		if (!isValid) {
			return;
		}

		this.loading = true;

		const params = {
			name: this.name,
			email: this.email,
			phoneNumber: this.phoneNumber,
			adminEmail: this.adminEmail
		};

		customer
			.add({ customer: params, link: '/customers' })
			.then((): void => {
				notifier.success('created', 'user');
				router.go(-1);
			})
			.catch((e): void => {
				(this.$refs.form as any).setErrors(validation.getErrors(e.errors));
				notifier.error('creating', 'user');
				this.loading = false;
			});
	}

	cancel() {
		router.go(-1);
	}
}
